export const deleteUndefined = (obj: any) => {
  for (const key in obj) {
    if (obj[key] === undefined || obj[key] === null) {
      delete obj[key];
    } else if (Array.isArray(obj[key])) {
      obj[key].forEach((item: any) => {
        if (item && typeof item === 'object') {
          deleteUndefined(item);
        }
      });
    } else if (typeof obj[key] === 'object') {
      deleteUndefined(obj[key]);
    }
  }
  return obj;
};
